(function () {
    if (!window.customerWishlist) {
        window.customerWishlist = {
            defaultList: null,
        };
    }

    const wishlistMainContainer = document.getElementById('ProductGridContainer');
    const wishlistContentsContainer = document.getElementById('wishlist-items-container');
    const wishlistErrorsContainer = document.getElementById('wishlist-error-container');
    const wishlistEmptyContainer = document.getElementById('wishlist-empty-container');

    function onSwymLoadCallback(swat) {
        if (!window.customerWishlist.defaultList) {
            swat.fetchLists({
                callbackFn: (lists) => {
                    let defaultWishlist = null;
                    for (let wishlist of lists) {
                        if (wishlist.lname === 'My Wishlist') {
                            window.customerWishlist.defaultList = wishlist;
                            break;
                        }
                    }
                    if (!window.customerWishlist.defaultList) {
                        showEmptyMessage();
                        return;
                    } else fetchListContent();
                },
                errorFn: showErrorMessage,
            });
        } else fetchListContent();

        function fetchListContent() {
            swat.fetchListCtx(
                { lid: window.customerWishlist.defaultList.lid },
                async (listContents) => {
                    if (listContents.length < 1) {
                        showEmptyMessage();
                        return;
                    }
                    // let wishlistedProducts = await fetchProductData(listContents);
                    let wishlistedProducts = await fetchProductDataGraphql(listContents);
                    if (wishlistedProducts) {
                        wishlistedProducts = wishlistedProducts.filter(Boolean);
                    }
                    if (!wishlistedProducts) {
                        showEmptyMessage();
                        return;
                    }
                    // const formattedWishlistedProducts = wishlistedProducts.map((wishlistItem) => {
                    //     let { product } = wishlistItem;
                    //     // Check if product is already in cart
                    //     product.isInCart =
                    //         swat.platform.isInDeviceCart(product.epi) || product.et == swat.EventTypes.addToCart;
                    //
                    //     // Placeholder image
                    //     const fallbackImage =
                    //         'https://cdn.shopify.com/s/files/1/0652/6789/2395/files/wine-no-image.webp?v=1727275599';
                    //
                    //     // Generate img attributes
                    //     if (product.productData && product.productData.media && product.productData.media[0]) {
                    //         const srcMedia = `${product.productData.media[0].src}&width=533`;
                    //         const srcSetMedia = getMediaSrcSet(product.productData.media[0]);
                    //         const altMedia = product.productData.media[0].alt;
                    //         const widthMedia = product.productData.media[0].width;
                    //         const heightMedia = product.productData.media[0].height;
                    //
                    //         product.media = {
                    //             src: srcMedia,
                    //             srcSet: srcSetMedia,
                    //             alt: altMedia,
                    //             width: widthMedia,
                    //             height: heightMedia,
                    //         };
                    //         product.hasMedia = true;
                    //     } else {
                    //         product.media = {
                    //             src: fallbackImage,
                    //             srcSet: fallbackImage,
                    //             alt: 'No image available',
                    //             width: 533,
                    //         };
                    //         product.hasMedia = true;
                    //     }
                    //
                    //     // Hover image
                    //     if (product.productData && product.productData.media && product.productData.media[1]) {
                    //         const srcMediaHover = `${product.productData.media[1].src}&width=533`;
                    //         const srcSetMediaHover = getMediaSrcSet(product.productData.media[1]);
                    //         const altMediaHover = product.productData.media[1].alt;
                    //         const widthMediaHover = product.productData.media[1].width;
                    //         const heightMediaHover = product.productData.media[1].height;
                    //
                    //         product.mediaHover = {
                    //             src: srcMediaHover,
                    //             srcSet: srcSetMediaHover,
                    //             alt: altMediaHover,
                    //             width: widthMediaHover,
                    //             height: heightMediaHover,
                    //         };
                    //         product.hasMediaHover = true;
                    //     } else product.hasMediaHover = false;
                    //
                    //     // Check vendor
                    //     if (product.productData.vendor && product.productData.vendor.trim() !== '')
                    //         product.hasVendor = true;
                    //     else product.hasVendor = false;
                    //
                    //     // Handle price and compare_at_price
                    //     product = SwymUtils.formatProductPrice(product);
                    //     product.pr = (product.productData.price / 100).toFixed(2).replace('.', ',');
                    //     if (product.productData.compare_at_price > product.productData.price) {
                    //         product.hasDiscount = true;
                    //         product.comparePrice = (product.productData.compare_at_price / 100)
                    //             .toFixed(2)
                    //             .replace('.', ',');
                    //     } else product.hasDiscount = false;
                    //
                    //     return product;
                    // });
                    //
                    // const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
                    //     products: formattedWishlistedProducts,
                    // });

                    const productCardsMarkup = wishlistedProducts
                        .map((node, index) =>
                            window.ShopifyStorefront.productCardMarkup({
                                node,
                                aspectRatio: 'portrait',
                                imageShape: 'default',
                                sectionId: 'my-wishlist-page',
                                colorScheme: 'scheme-4',
                                quickAdd: 'standard',
                                showVendor: 'true',
                                zIndex: index + 1,
                                isWishlist: true,
                            }),
                        )
                        .join('');

                    if (wishlistContentsContainer) {
                        wishlistContentsContainer.innerHTML = productCardsMarkup;
                        attachListener();
                    }
                },
                showErrorMessage,
            );
        }

        async function fetchProductDataGraphql(wishlist) {
            try {
                const ids = wishlist.map((wishlistItem) => `gid://shopify/Product/${wishlistItem.empi}`);
                const queryContent = ids
                    .map(
                        (id, index) => `
                        product${index}: product(id:"${id}"){
                            ${window.ShopifyStorefront.productQuery()}
                        }
                    `,
                    )
                    .join('\n');
                const query = `
                    query getProducts($language: LanguageCode!, $country: CountryCode!)@inContext(country: $country, language: $language){
                        ${queryContent}
                    }`;
                const variables = {
                    language: Shopify.locale.toUpperCase(),
                    country: Shopify.country,
                };

                const responseResults = await window.ShopifyStorefront.executeQuery(query, variables);
                return Object.values(responseResults.data).filter(Boolean);
            } catch (error) {
                console.error('fetchProductDataGraphql', error);
            }
        }

        async function fetchProductData(wishlist) {
            try {
                let fetchedProucts = await Promise.all(
                    wishlist.map(async (listItem) => {
                        let productHandle = listItem.du.split('?')[0];
                        try {
                            let response = await fetch(productHandle + '.js');
                            if (!response.ok) {
                                throw new Error(`${response.status}`);
                            }
                            let productData = await response.json();
                            listItem.product.productData = productData;
                            return listItem;
                        } catch (error) {
                            switch (error.message) {
                                case '404': {
                                    let product = {
                                        epi: listItem.epi,
                                        empi: listItem.empi,
                                        du: listItem.du,
                                    };
                                    swat.deleteFromList(
                                        listItem.lid,
                                        product,
                                        function (error) {
                                            // Error is an xhrObject
                                            console.error('Error while deleting the Product', error);
                                        },
                                        function (deletedProduct) {
                                            // Executed when product is successfully deleted
                                            console.info('Successfully deleted the Product', deletedProduct);
                                        },
                                    );
                                    return null;
                                }
                                default:
                                    return null;
                            }
                        }
                    }),
                );
                return fetchedProucts;
            } catch (error) {
                console.error('wishlist-page.js fetching product error', error);
                // showErrorMessage();
            }
        }

        function attachListener() {
            const removeFromWishlistButton = window.document.querySelectorAll('.js_remove-from-wishlist-button');
            if (removeFromWishlistButton.length < 1) return;

            removeFromWishlistButton.forEach((button) => {
                button.addEventListener(
                    'click',
                    removeFromWishlist.bind(button, window.customerWishlist.defaultList.lid),
                );
            });
        }

        function removeFromWishlist(lid) {
            const productContainer = this.parentElement;
            productContainer?.classList.add('swym-loading');
            const empi = this.getAttribute('data-empi');
            const epi = this.getAttribute('data-epi');
            const du = this.getAttribute('data-du');

            const product = {
                epi,
                empi,
                du,
            };
            swat.deleteFromList(
                lid,
                product,
                () => {
                    productContainer.parentElement.remove();

                    // Check if there are any remaining items in the wishlist
                    const remainingItems = document.querySelectorAll('#wishlist-items-container > *');
                    if (remainingItems.length === 0) {
                        showEmptyMessage();
                    }
                },
                showErrorMessage,
            );
        }

        function showErrorMessage() {
            if (wishlistMainContainer && wishlistErrorsContainer) {
                wishlistMainContainer.classList.add('d-none');
                wishlistErrorsContainer.classList.remove('d-none');
                wishlistErrorsContainer.classList.add('d-flex');
            }
        }

        function showEmptyMessage() {
            if (wishlistMainContainer && wishlistEmptyContainer) {
                wishlistMainContainer.classList.add('d-none');
                wishlistEmptyContainer.classList.remove('d-none');
                wishlistEmptyContainer.classList.add('d-flex');
            }
        }

        function getMediaSrcSet(image) {
            if (!image) return false;

            let srcSet = [];

            if (image.width >= 165) srcSet.push(`${image.src}&width=165 165w`);
            if (image.width >= 360) srcSet.push(`${image.src}&width=360 360w`);
            if (image.width >= 533) srcSet.push(`${image.src}&width=533 533w`);
            if (image.width >= 720) srcSet.push(`${image.src}&width=720 720w`);
            if (image.width >= 940) srcSet.push(`${image.src}&width=940 940w`);
            if (image.width >= 1066) srcSet.push(`${image.src}&width=1066 1066w`);

            // Aggiunta finale con l'immagine originale
            srcSet.push(`${image.src} ${image.width}w`);

            return srcSet.join(', ');
        }
    }

    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
})();
